import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-dynamic-viewer',
  templateUrl: './dynamic-viewer.component.html',
  styleUrls: ['./dynamic-viewer.component.scss'],
})
export class DynamicViewerComponent {
  @Input() data: any;
  @Input() schema: any;
  @Input() fieldTitles: any;
  @Input() titulo: string;

  constructor(protected ref: NbDialogRef<DynamicViewerComponent>) {}

  dismiss() {
    this.ref.close();
  }

  isObject(val: any): boolean {
    return val && typeof val === 'object' && !Array.isArray(val);
  }

  isArray(val: any): boolean {
    return Array.isArray(val);
  }

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  toDisplayName(key: string): string {
    if (!key) return '';
    if (this.fieldTitles[key] && this.fieldTitles[key] != '') return this.fieldTitles[key];
    // Inserta espacios antes de mayúsculas y capitaliza la primera letra
    return key
      .replace(/([A-Z])/g, ' $1') // Ej: "firstName" → "first Name"
      .replace(/^./, (str) => str.toUpperCase()) // "first Name" → "First Name"
      .trim();
  }

  getOrderedKeys(obj: any): string[] {
    if (!obj) return [];

    return Object.keys(obj).sort((a, b) => {
      const titleA = this.fieldTitles?.[a] || this.toDisplayName(a);
      const titleB = this.fieldTitles?.[b] || this.toDisplayName(b);
      return titleA.localeCompare(titleB, 'es', { sensitivity: 'base' });
    });
  }

}
